// extracted by mini-css-extract-plugin
export default {"main":"BasicForm_main__52iAp","form":"BasicForm_form__Z3Fds","input":"BasicForm_input__k-oIF","footer":"BasicForm_footer__s716V"};